var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_83)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8692 10.9124C27.6907 11.5047 32.0195 15.8235 31.5377 20.5587C31.1834 24.041 26.7725 28.7557 24.8304 31.4256L18.9614 39.4926L14.8373 30.4089C13.4719 27.4025 10.1017 21.8961 10.456 18.4138C10.9378 13.6786 16.0477 10.3201 21.8692 10.9124Z",
    fill: "#7C7C7C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C25.6274 0 31 5.3726 31 12C31 16.8737 26.5704 24.0265 24.6882 27.9987L19 40.0006L13.3118 27.9987C11.4287 24.0265 7 16.8737 7 12C7 5.3726 12.3726 0 19 0Z",
    fill: "#0C2A48"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4166 9.78127C19.9736 9.78127 19.6145 10.1404 19.6145 10.5834V11.0417C19.6145 11.4847 19.9736 11.8438 20.4166 11.8438C20.8596 11.8438 21.2187 11.4847 21.2187 11.0417V10.5834C21.2187 10.1404 20.8596 9.78127 20.4166 9.78127ZM20.302 10.5834C20.302 10.5201 20.3533 10.4688 20.4166 10.4688C20.4799 10.4688 20.5312 10.5201 20.5312 10.5834V11.0417C20.5312 11.105 20.4799 11.1563 20.4166 11.1563C20.3533 11.1563 20.302 11.105 20.302 11.0417V10.5834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5729 8.29169V15.1667C14.5729 15.8628 15.1372 16.4271 15.8333 16.4271L23.1666 16.4271C23.8627 16.4271 24.427 15.8628 24.427 15.1667V11.3472C24.427 11.0745 24.3386 10.8092 24.175 10.591L23.1375 9.20774C22.9988 9.0228 22.8119 8.87957 22.5973 8.79372L20.8847 8.10869C20.5842 7.98849 20.249 7.98849 19.9485 8.10869L18.236 8.79372C18.1566 8.82545 18.0811 8.86502 18.0104 8.91163V8.29169C18.0104 7.34245 17.2409 6.57294 16.2916 6.57294C15.3424 6.57294 14.5729 7.34245 14.5729 8.29169ZM17.3229 8.29169V9.70488L16.6583 10.591C16.4947 10.8092 16.4062 11.0745 16.4062 11.3472V15.1667C16.4062 15.373 16.4558 15.5677 16.5436 15.7396H15.8333C15.5169 15.7396 15.2604 15.4831 15.2604 15.1667V8.29169C15.2604 7.72214 15.7221 7.26044 16.2916 7.26044C16.8612 7.26044 17.3229 7.72214 17.3229 8.29169ZM22.1354 15.7396V13.7917C22.1354 13.0956 21.5711 12.5313 20.875 12.5313H19.9583C19.2622 12.5313 18.6979 13.0956 18.6979 13.7917V15.7396H17.6666C17.3502 15.7396 17.0937 15.4831 17.0937 15.1667V11.3472C17.0937 11.2233 17.1339 11.1027 17.2083 11.0035L18.2457 9.62024C18.3088 9.53617 18.3937 9.47107 18.4913 9.43205L20.2038 8.74702C20.3404 8.69239 20.4928 8.69239 20.6294 8.74702L22.342 9.43205C22.4395 9.47107 22.5245 9.53617 22.5875 9.62024L23.625 11.0035C23.6993 11.1027 23.7395 11.2233 23.7395 11.3472V15.1667C23.7395 15.4831 23.483 15.7396 23.1666 15.7396H22.1354ZM19.3854 13.7917C19.3854 13.4753 19.6419 13.2188 19.9583 13.2188H20.875C21.1914 13.2188 21.4479 13.4753 21.4479 13.7917V15.7396H19.3854V13.7917Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(14 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinFarm);
export default __webpack_public_path__ + "static/media/pin-farm.5044b00390fd4ce41589497225d32c74.svg";
export { ForwardRef as ReactComponent };